import { Link } from '@inertiajs/react';
import { ArrowUpRight } from 'lucide-react';
import SearchHighlight from '@/theme2/components/search/SearchHighlight';

export default function SearchResultCard({ item, query, active, onSelect }) {
    return (
        <Link
            href={item.url}
            onClick={onSelect}
            className={`flex items-center gap-4 rounded-2xl p-3 transition focus:ring-2 focus:ring-ring focus:outline-none ${
                active ? 'bg-neutral-100' : 'hover:bg-neutral-100/70'
            }`}
        >
            <div className="flex size-16 shrink-0 items-center justify-center overflow-hidden rounded-2xl bg-slate-300">
                {item.image ? (
                    <img
                        src={item.image}
                        alt={item.title}
                        className="size-full object-cover"
                    />
                ) : (
                    <SearchHighlight
                        text={item.title.slice(0, 2).toUpperCase()}
                        query=""
                    />
                )}
            </div>

            <div className="min-w-0 flex-1">
                <p className="truncate text-sm font-semibold text-foreground">
                    <SearchHighlight text={item.title} query={query} />
                </p>
                <p className="mt-1 truncate text-xs text-muted-foreground">
                    <SearchHighlight text={item.subtitle} query={query} />
                </p>
            </div>

            <ArrowUpRight
                className="size-4 text-muted-foreground"
                aria-hidden="true"
            />
        </Link>
    );
}
